import * as React from "react";
import { TranslatableInputs, TextInput, Edit, TabbedForm, FormTab, BooleanInput, ImageInput, ImageField, FormDataConsumer, useLocale } from 'react-admin';
import { validateRequired } from "../../lib/validations";
import GoogleMapInput from "../../components/GoogleMapInput";
import { locales } from "../../lib/utils";

const mapOptions = {
    clickableIcons: false,
}

const SignpostingTitle = ({ record }) => {
    const locale = useLocale();
    return <span>{record ? record.title[locale] : ''}</span>;
};

const SignpostingEdit = (props) => {
    return (
        <Edit title={<SignpostingTitle />} {...props}>
            <TabbedForm redirect="edit">
                <FormTab label="Conteúdo">
                    <TranslatableInputs locales={locales}>
                        <TextInput source="title" validate={validateRequired} />
                    </TranslatableInputs>
                </FormTab>
                <FormTab label="Imagens">
                    <ImageInput source="image" label="Imagem de capa" accept="image/*">
                        <ImageField source="src" title="title" />
                    </ImageInput>
                </FormTab>
                <FormTab label="Localização">
                    <GoogleMapInput source="location" zoom={12} validate={validateRequired} options={mapOptions} />
                </FormTab>
                <FormTab label="Notificações">
                    <BooleanInput source="notification[enabled]" label="Ativar notificação para este POI" />
                    <FormDataConsumer>
                        {({ formData, ...rest }) => {
                            return ((formData.notification && formData.notification.enabled) && <TextInput source="notification[content]" label="Descrição" multiline {...rest} />)
                        }}
                    </FormDataConsumer>

                </FormTab>
            </TabbedForm>
        </Edit>
    )
};

export default SignpostingEdit;